import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer, EuiButton } from "@elastic/eui";
import NavButtons from "components/Outdoor_Cameras/IN-9808_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9808 4K (QFHD) Handbuch",
  "path": "/Aussenkameras/IN-9808_QFHD/Handbuch/",
  "dateChanged": "2022-10-08",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR IN-9808 4K (QFHD) Outdoor IP Kamera Benutzerhandbuch",
  "image": "../P_SearchThumb_IN-9408WQHD.png",
  "social": "/images/Search/P_SearchThumb_IN-9408WQHD.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title="IN-9808 4K (QFHD) Usermanual" dateChanged="2017-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="INSTAR IN-9808 4K (QFHD) Outdoor IP Kamera Benutzerhandbuch" image="/images/Search/P_SearchThumb_IN-9008HD.png" twitter="/images/Search/P_SearchThumb_IN-9008HD.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9808_QFHD/Usermanual/" locationFR="/fr/Outdoor_Cameras/IN-9808_QFHD/Usermanual/" crumbLabel="Handbuch" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "in-9808-4k-qfhd-benutzerhandbuch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#in-9808-4k-qfhd-benutzerhandbuch",
        "aria-label": "in 9808 4k qfhd benutzerhandbuch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-9808 4K (QFHD) Benutzerhandbuch`}</h1>
    <h2 {...{
      "id": "online-produktbeschreibung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#online-produktbeschreibung",
        "aria-label": "online produktbeschreibung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Online-Produktbeschreibung`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/4c1112959d165b338ce586e690a6d381/ea64c/IN-9808QFHD_Scope_of_Delivery.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "22.608695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAAxklEQVQY001QWw7DIAzj/pfrCdhPWWnpYzxa+q4nR0NaJGQSbJxEHceB67rwPA/u+0YJ5nwjnucp9//3dV2l/h/btkFRMAwDrLV4aY1lWTCnhBgjqqoSUl3X0Fpjnmf5dN93eO+FE0JA13XCo4GiMwnBe/mYpGmaREwyDdJPuOYsOYV938M5J/W2bZFzFq1KKYlrERdX1uMPS15ODFEaIJc5uyWyIcXuuA+ijPLxMMbIClpr4Ton2DSN1N7GYBxHlMnKKSN/AdurgMiLyeUZAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4c1112959d165b338ce586e690a6d381/e4706/IN-9808QFHD_Scope_of_Delivery.avif 230w", "/de/static/4c1112959d165b338ce586e690a6d381/d1af7/IN-9808QFHD_Scope_of_Delivery.avif 460w", "/de/static/4c1112959d165b338ce586e690a6d381/7f308/IN-9808QFHD_Scope_of_Delivery.avif 920w", "/de/static/4c1112959d165b338ce586e690a6d381/91422/IN-9808QFHD_Scope_of_Delivery.avif 1116w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/4c1112959d165b338ce586e690a6d381/a0b58/IN-9808QFHD_Scope_of_Delivery.webp 230w", "/de/static/4c1112959d165b338ce586e690a6d381/bc10c/IN-9808QFHD_Scope_of_Delivery.webp 460w", "/de/static/4c1112959d165b338ce586e690a6d381/966d8/IN-9808QFHD_Scope_of_Delivery.webp 920w", "/de/static/4c1112959d165b338ce586e690a6d381/36c36/IN-9808QFHD_Scope_of_Delivery.webp 1116w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/4c1112959d165b338ce586e690a6d381/81c8e/IN-9808QFHD_Scope_of_Delivery.png 230w", "/de/static/4c1112959d165b338ce586e690a6d381/08a84/IN-9808QFHD_Scope_of_Delivery.png 460w", "/de/static/4c1112959d165b338ce586e690a6d381/c0255/IN-9808QFHD_Scope_of_Delivery.png 920w", "/de/static/4c1112959d165b338ce586e690a6d381/ea64c/IN-9808QFHD_Scope_of_Delivery.png 1116w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/4c1112959d165b338ce586e690a6d381/c0255/IN-9808QFHD_Scope_of_Delivery.png",
              "alt": "IN-9808 4K (QFHD) Online Handbuch",
              "title": "IN-9808 4K (QFHD) Online Handbuch",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Die IN-9808 4K (QFHD) ist eine wetterfeste und kabellose Außenkamera mit eingebauten Hochleistungs-Infrarotdioden, mit denen Sie tief in die Dunkelheit sehen können. Der integrierte IR-Sperrfilter wiederum ermöglicht die Erfassung von natürlichen Farben am Tag, wie sie das menschliche Auge sieht.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "720px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/658d6ea68113ace8234d395f2c55d16f/37523/IN-9408WQHD_Halterung.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "105.65217391304347%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAIAAADJt1n/AAAACXBIWXMAAA7DAAAOwwHHb6hkAAACTUlEQVQ4y42U224TMRBA8//fwB8g8YrEI5UQQkgViEKRiNQ2pG2y3ou9vo3nBvYmgRa1Yt5212c9PjPjlaqKCCJqC2ZOKRHR8igixCzM3vsYI6nSzRo/fVy+rVSViIwxiJhzvm+Rcz78S9Vsrvz5mdnc7Pb7aZ79z+v88oViUdXVsts4jgAQYxyMcc7lnEWEt7dC3H/7bM9eO2uds+M0gXfw5b20TA+wtRYRBdH2/TBZqqgIFGGaY3J9N9//BCQiVoTorLS8Vqezqeo8DFM/2N3dbPazDyrLGvXeQyn6T6z+fgjOBR/Iuzw7Yn60VFo8CR8kPVzxTBxsW2vrgZq53pgCcFphmz9lhhg603vvH8PGmFKK977rur7rcko1BesUcW9MjDGVsnnz6ub8g4vpAczM0zQBQCmlH4Zh2ZmZO6OIwzRWOPjLd2+vv1/mUk4nXy0mylEmQAnOceuwxVBKmUUQcj/0dp5Tik8KY8T7zcbbyd/ejMMIGU6qaws/FP4YFuYUAhZA704N/5zt56M2W6u5ECXv5Tgzf4RRCyQCgLkNEENRJGW+3W5bqUSIZudqVx/5A1xKQUQE8Nb2u11KqZIiOaWrH+ulcimlrxcXPgRlXjq3wqUUIhIi8j6EwM18PXmG4Nw0jqVNaIxxvV5X+KjtUCrvK+edY0RF1Dr/jDlLzpAztpfcWhByrmmfYFVFXLIGYZaUlFmOLoZhqEPCzDmTSHROjzOzekYyIoYQxnFcbqWU0na73Xfdf5VqKVK9xho8z/Pt3d3phvoN/wJEVMqdwSc9ZwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/658d6ea68113ace8234d395f2c55d16f/e4706/IN-9408WQHD_Halterung.avif 230w", "/de/static/658d6ea68113ace8234d395f2c55d16f/d1af7/IN-9408WQHD_Halterung.avif 460w", "/de/static/658d6ea68113ace8234d395f2c55d16f/f7eb3/IN-9408WQHD_Halterung.avif 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/658d6ea68113ace8234d395f2c55d16f/a0b58/IN-9408WQHD_Halterung.webp 230w", "/de/static/658d6ea68113ace8234d395f2c55d16f/bc10c/IN-9408WQHD_Halterung.webp 460w", "/de/static/658d6ea68113ace8234d395f2c55d16f/bc514/IN-9408WQHD_Halterung.webp 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/658d6ea68113ace8234d395f2c55d16f/81c8e/IN-9408WQHD_Halterung.png 230w", "/de/static/658d6ea68113ace8234d395f2c55d16f/08a84/IN-9408WQHD_Halterung.png 460w", "/de/static/658d6ea68113ace8234d395f2c55d16f/37523/IN-9408WQHD_Halterung.png 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/658d6ea68113ace8234d395f2c55d16f/37523/IN-9408WQHD_Halterung.png",
              "alt": "IN-9808 4K (QFHD) Online Handbuch",
              "title": "IN-9808 4K (QFHD) Online Handbuch",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "inhaltsverzeichnis",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#inhaltsverzeichnis",
        "aria-label": "inhaltsverzeichnis permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Inhaltsverzeichnis`}</h3>
    <ul>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/" mdxType="Link">Übersicht</Link>
      </li>
      <li parentName="ul">
        <Link to="#" mdxType="Link">Online Handbuch</Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Schnell_Installation/" mdxType="Link">
  Kamerainstallation
        </Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Sicherheit_Hinweise/" mdxType="Link">
  Sicherheit Hinweise
        </Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Produkt_Features/" mdxType="Link">
  Produkt Features
        </Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Technische_Spezifikationen/" mdxType="Link">
  Technische Spezifikationen
        </Link>
      </li>
      <li parentName="ul">
        <Link to="/Web_User_Interface/1440p_Serie/" mdxType="Link">Web User Interface</Link>
      </li>
      <li parentName="ul">
        <Link to="/Schnell_Installation/WebUI_und_Firmware_Upgrade/" mdxType="Link">
  Software Update
        </Link>
      </li>
      <li parentName="ul">
        <Link to="/Downloadbereich/Aussenkameras/IN-9808_QFHD/" mdxType="Link">Downloads</Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Video_Streaming/" mdxType="Link">Video Streaming</Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Kamera_Reset/" mdxType="Link">Kamera Reset</Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Objektivjustage/" mdxType="Link">Objektivjustage</Link>
      </li>
      <li parentName="ul">
        <Link to="/Aussenkameras/IN-9808_QFHD/Garantie/" mdxType="Link">Garantie & Entsorgung</Link>
      </li>
    </ul>
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "laden-sie-unser-druckhandbuch-herunter",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#laden-sie-unser-druckhandbuch-herunter",
        "aria-label": "laden sie unser druckhandbuch herunter permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Laden Sie unser Druckhandbuch herunter`}</h2>
    <OutboundLink href="https://wiki.instar.com/dl/IN-9808QFHD/QuickInstallation-2160p-IN-9808QFHD.pdf" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">
  <EuiButton fill mdxType="EuiButton">PDF Druckhandbuch</EuiButton>
    </OutboundLink>
    <h2 {...{
      "id": "häufige-fragen-am-anfang",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#h%C3%A4ufige-fragen-am-anfang",
        "aria-label": "häufige fragen am anfang permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Häufige Fragen am Anfang`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#online-produktbeschreibung"
        }}>{`Online Produktbeschreibung`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#Verf%C3%BCgbare-Youtube-Videos"
        }}>{`Verfügbare Youtube Videos`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#Download-PDF-Handbuch"
        }}>{`Download PDF Handbuch`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#H%C3%A4ufige-Fragen-am-Anfang"
        }}>{`Häufige Fragen am Anfang`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#speicherm%C3%B6glichkeiten-der-kameraaufnahmen"
            }}>{`Speichermöglichkeiten der Kameraaufnahmen`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#zugriff-auf-die-kamera-via-smartphone-app"
            }}>{`Zugriff auf die Kamera via Smartphone-App`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#anschlusskabel-der-au%C3%9Fenkameras"
            }}>{`Anschlusskabel der Außenkameras`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#heizung-f%C3%BCr-die-au%C3%9Fenkamera"
            }}>{`Heizung für die Außenkamera`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#zoom-objektiv"
            }}>{`Zoom-Objektiv`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#baterie-undoder-sim-card"
            }}>{`Battery and/or SIM-Card`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#l%C3%A4nge-der-alarmvideos"
            }}>{`Länge der Alarmvideos`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#synology-surveillance-station-and-qnap-nas"
            }}>{`Synology Surveillance Station and QNAP NAS`}</a></li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "speichermöglichkeiten-der-kameraaufnahmen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#speicherm%C3%B6glichkeiten-der-kameraaufnahmen",
        "aria-label": "speichermöglichkeiten der kameraaufnahmen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Speichermöglichkeiten der Kameraaufnahmen`}</h3>
    <p>{`Es gibt insgesamt `}<strong parentName="p">{`fünf`}</strong>{` verschiedene Speichermöglichkeiten für `}<a parentName="p" {...{
        "href": "/de/Bewegungserkennung/Alarm_Aufnahme/"
      }}>{`Video Aufnahmen`}</a>{` bei unseren Überwachungskameras:`}</p>
    <ol>
      <li parentName="ol">{`Alle unsere 4K (QFHD) IP-Kameras werden mit einer internen SD-Karte mit einer Kapazität von 32 GB (austauschbar bis zu 1 TB) geliefert. `}<OutboundLink href="https://www.instar.com/support/help-tools" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink">{`hier`}</OutboundLink>{` können Sie berechnen, wie lange es dauert, bis der Speicher der SD-Card voll ist. Die ältesten Aufnahmen auf der Kamera werden standardmäßig überschrieben (Ringspeicher). `}<Link to="/Bewegungserkennung/SD_Karten_Zugriff/" mdxType="Link">{`Zugriff auf Ihre SD-Karte`}</Link>{` mit unserer Smartphone-App InstarVision für `}<Link to="/Software/Android/InstarVision/Recording/" mdxType="Link">{`Android`}</Link>{`, `}<Link to="/Software/iOS/InstarVision/iPhone/Recording/" mdxType="Link">{`iPhone`}</Link>{`, `}<Link to="/Software/iOS/InstarVision/iPad/Recording/" mdxType="Link">{`iPad`}</Link>{`, `}<Link to="/Software/Andere_Plattform/InstarVision_Blackberry/" mdxType="Link">{`Blackberry`}</Link>{`, `}<Link to="/Software/Windows/InstarVision/Windows_Phone/Recording/" mdxType="Link">{`Windows Phone`}</Link>{` und `}<Link to="/Software/Windows/InstarVision/Metro/Recording/" mdxType="Link">{`Windows 8/10`}</Link>{`.`}</li>
      <li parentName="ol">{`Wir bieten eine `}<strong parentName="li">{`Cloud`}</strong>{`-Lösung zum einfachen Speichern von Aufnahmen Ihrer INSTAR-Kameras. Die `}<Link to="/Bewegungserkennung/INSTAR_Cloud/" mdxType="Link">{`INSTAR Cloud`}</Link>{` bietet eine leicht zugängliche Oberfläche und eine gute Möglichkeit, Ihre Aufnahmen zu verwalten. Wenn Sie Angst haben, dass Ihre Kamera und SD-Karte zerstört werden könnten, gibt Ihnen die INSTAR Cloud die Möglichkeit, Ihre Aufnahmen zu sichern.`}</li>
      <li parentName="ol">{`Sie können das `}<Link to="/Software/Windows/InstarVision/" mdxType="Link">{`InstarVision 2.0 Surveillance Center`}</Link>{` verwenden, eine `}<strong parentName="li">{`Windows PC Software`}</strong>{` von uns. Mit dieser Software ist es nicht nur möglich, das Live-Video aller Ihrer Kameras gleichzeitig anzuzeigen, Sie können auch Aufzeichnungen starten und auf Ihrem Computer speichern.`}</li>
      <li parentName="ol">{`Es ist auch möglich, den Dienst `}<strong parentName="li">{`FTP`}</strong>{` (File Transfer Protocol) zu nutzen, um Ihre Aufnahmen an andere Geräte zu senden, z. B. an einen `}<Link to="/Bewegungserkennung/Router_als_FTP_Server/" mdxType="Link">{`USB-Stick, der mit Ihrem Router verbunden ist`}</Link>{` oder eine Festplatte in Ihrem Netzwerk.`}</li>
      <li parentName="ol">{`Wenn Sie permanente Aufnahmen machen wollen, können Sie auch `}<strong parentName="li">{`NAS-Systeme`}</strong>{` verwenden, z.B. `}<Link to="/Software/Andere_Plattform/Synology/" mdxType="Link">{`Synology`}</Link>{` oder `}<Link to="/Software/Andere_Plattform/QNAP/" mdxType="Link">{`QNAP`}</Link>{`. Diese haben eine eigene Überwachungssoftware und unterstützen alle unsere Kameramodelle.`}</li>
    </ol>
    <p><strong parentName="p">{`Zusatz`}</strong>{`: Sie können auch den `}<Link to="/Bewegungserkennung/Alarm_Benachrichtigung/" mdxType="Link">{`Email-Service`}</Link>{` aktivieren, um Snapshots per E-Mail zu erhalten, nachdem ein Alarm ausgelöst wurde.`}</p>
    <h3 {...{
      "id": "zugriff-auf-die-kamera-via-smartphone-app",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#zugriff-auf-die-kamera-via-smartphone-app",
        "aria-label": "zugriff auf die kamera via smartphone app permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zugriff auf die Kamera via Smartphone-App`}</h3>
    <p>{`Mit unserer kostenlosen App `}<strong parentName="p">{`InstarVision`}</strong>{` für `}<a parentName="p" {...{
        "href": "/de/Software/Android/InstarVision/"
      }}>{`Android`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/iOS/InstarVision/iPhone/"
      }}>{`iPhone`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/iOS/InstarVision/iPad/"
      }}>{`iPad`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/Andere_Plattform/InstarVision_Blackberry/"
      }}>{`Blackberry`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Windows_Phone/"
      }}>{`Windows Phone`}</a>{` und `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Metro/"
      }}>{`Windows 8/10`}</a>{` können Sie einfach das Livebild Ihrer Sicherheitskamera aufrufen. Ausserdem können Sie mit der App von unterwegs jederzeit auf die Speicherkarte zugreifen und sich die Videos anschauen, die aufgenommen wurden. Auch Anwendungen, wie z. B. Alarm ein-/ausschalten oder die Kamera als Gegensprechanlage zu nutzen, können Sie damit realisieren.`}</p>
    <h3 {...{
      "id": "anschlusskabel-der-außenkameras",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#anschlusskabel-der-au%C3%9Fenkameras",
        "aria-label": "anschlusskabel der außenkameras permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Anschlusskabel der Außenkameras`}</h3>
    <p>{`Bis auf unsere FullHD-Modelle haben alle unsere Kameras einen so genannten `}<strong parentName="p">{`Kabelbaum`}</strong>{`, der aus allen Kabelanschlüssen der Kamera besteht. Dieser Kabelbaum ist 80cm lang und relativ dick. Wenn Sie kein großes Loch durch Ihre Wand bohren wollen, können Sie diese Kabel`}<strong parentName="p">{` von Ihrer Kamera `}</strong>{`entfernen und dann das "dünne Ende" durch die Wand führen.`}</p>
    <p>{`Von einem Abschneiden nicht benötigter Kabel raten wir dringend ab. Nicht nur verlieren Sie dadurch die Garantie für Ihre Überwachungskamera, sondern Sie riskieren auch irreparable Schäden an der Kamera. Eine Lösung wäre das Kabel in einer wetterfesten Kabelbox zu verlegen, wie man sie im Baumarkt findet (Wir selbst bieten solch ein Produkt nicht an). Dabei ist zu beachten, dass die Kabel von unten und nicht von oben in die Box führen, sodass z. B. Regen nicht am Kabel entlang in die Box laufen kann. Wenn benötigt, bieten wir auch `}<a href="https://www.instar.de/accessories/power-supply-cables.html" target="_blank" rel="noopener noreferrer">{`Verlängerungskabel`}</a>{` zwischen 3-5 m an.`}</p>
    <h3 {...{
      "id": "heizung-für-die-außenkamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#heizung-f%C3%BCr-die-au%C3%9Fenkamera",
        "aria-label": "heizung für die außenkamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Heizung für die Außenkamera`}</h3>
    <p>{`Ob eine Heizung für Ihre Überwachungskamera notwendig ist oder nicht hängt vom Einsatzort ab. Die Kameras sind bei bis zu -5 Grad Celsius ohne Probleme einsatzbereit. Sollte es mal kälter werden und/oder die Kamera stark dem Wetter ausgesetzt sein, was in vielen Regionen Deutschlands der Fall ist, wird die Kamera keinen bleibenden Schaden abbekommen. Aber es kann passieren, dass die Aussenkamera sich ausschaltet und vorübergehend nicht erreichbar ist. Der Einabau einer Heizung kann dann den dauerhaften Betrieb der Kamera sicherstellen. Die Heizungen für die Modelle `}<a href="https://www.instar.com/produkte/accessories/heaters.html" target="_blank" rel="noopener noreferrer">{`IN-9008 FHD`}</a>{`,`}<a href="https://www.instar.com/produkte/accessories/heaters.html" target="_blank" rel="noopener noreferrer">{`IN-7011 HD`}</a>{`, `}<a href="https://www.instar.com/produkte/accessories/heaters.html" target="_blank" rel="noopener noreferrer">{`IN-5907 HD`}</a>{`, `}<a href="https://www.instar.com/produkte/accessories/heaters.html" target="_blank" rel="noopener noreferrer">{`IN-5905 HD`}</a>{` finden Sie in unserem Webshop.`}</p>
    <h3 {...{
      "id": "zoom-objektiv",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#zoom-objektiv",
        "aria-label": "zoom objektiv permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zoom-Objektiv`}</h3>
    <p>{`Alle unsere 4K (QFHD) und 2k+ (WQHD) Kameras (mit Ausnahme der IN-9420 WQHD und IN-9820 QFHD) haben `}<strong parentName="p">{`keinen`}</strong>{` optischen Zoom, bieten aber einen digitalen Zoom.`}</p>
    <h3 {...{
      "id": "batterie-undoder-sim-card",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#batterie-undoder-sim-card",
        "aria-label": "batterie undoder sim card permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Batterie und/oder SIM-Card`}</h3>
    <p>{`Unsere Kameras verfügen über `}<strong parentName="p">{`keinen Akku`}</strong>{`, das heißt, die Kamera bedarf einer externen Stromversorgung, entweder über das mitgelieferte Netzteil oder, im Falle von Power over Ethernet (PoE) Überwachungskameras, über das Netzwerkkabel. Mehr Informationen zu unseren PoE Sicherheitskameras finden Sie `}<a href="https://www.instar.de/poe-netzwerkkameras.html" target="_blank" rel="noopener noreferrer">{`hier`}</a>{`. Im Gegensatz zu batteriebetriebenen Kameras nehmen INSTAR IP Kameras - bei aktivierter Bewegungserkennung - durchgehend ein Video auf. Bei einem Alarmereignis kann so die Videoaufnahme schon vor dem eigentliche Ereignis beginnen - unsere Alarmvideos haben somit einen `}<strong parentName="p">{`3-sekündigen Vorlauf`}</strong>{`.`}</p>
    <p>{`Unsere Kameras haben `}<strong parentName="p">{`keinen Sim-Karten-Slot`}</strong>{`. Wollen Sie die Kamera an einem Ort verwenden, an dem es keinen Internet-Zugang gibt, haben Sie die Möglichkeit einen mobilen LTE Router oder 3G Router zu verwenden und diesen mit einer Sim-Karte auszustatten. Die Kamera kann dann über diesen Router mit dem Internet verbunden werden und Ihnen den Zugriff über die App ermöglichen. Wir selbst bieten solche Router nicht an, Sie können sich aber bei einem Elektronik-Fachmarkt Ihrer Wahl darüber informieren. Natuerlich stehen Ihnen alle Kamerafunktionen, die keinen Internet Zugriff benoetigen (Bewegungserkennung, Alarm Videoaufnahme, usw.) auch ohne einen Internetzugriff zur Verfuegung - Sie koennen Ihre Kamera entweder `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/Direkte_LAN_Verbindung/"
      }}>{`direkt mit Ihrem Computer verbinden`}</a>{`, oder - wesentlich einfacher - einen alten WLAN Router (ohne Internet Zugang) vor Ort installieren.`}</p>
    <h3 {...{
      "id": "länge-der-alarmvideos",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#l%C3%A4nge-der-alarmvideos",
        "aria-label": "länge der alarmvideos permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Länge der Alarmvideos`}</h3>
    <p>{`Das Alarmvideo beginnt 3 Sekunden (einstellbar 0-10s) vor dem Alarmereignis und endet 15 Sekunden (einstellbar 15-60s) danach - insgesamt beträgt das Alarmvideo 17-18s mit Standardeinstellungen. Wenn die Bewegung nach der Aufnahme weitergeht, wird ein neues Alarmereignis ausgelöst und ein neues 15s-Video aufgezeichnet.`}</p>
    <h3 {...{
      "id": "synology-surveillance-station-and-qnap-nas",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#synology-surveillance-station-and-qnap-nas",
        "aria-label": "synology surveillance station and qnap nas permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Synology Surveillance Station and QNAP NAS`}</h3>
    <p><a parentName="p" {...{
        "href": "/de/Software/Andere_Plattform/Synology/"
      }}>{`Synology`}</a>{` and `}<a parentName="p" {...{
        "href": "/de/Software/Andere_Plattform/QNAP/"
      }}>{`QNAP`}</a>{` haben eine eigene Videoüberwachungssoftware und können das Livevideo unserer Überwachungskamera abgreifen und entsprechend verarbeiten. Endgeräte der Firmen Synology und QNAP vertreiben wir selbst nicht, wir haben aber gute Erfahrungen mit Produkten dieser Firmen gemacht und können diese daher empfehlen. All unsere HD, FullHD und 2k+ (WQHD) Kameras sind kompatibel. Für die Einbindung in eine Synology NAS haben wir `}<a parentName="p" {...{
        "href": "/de/Software/Andere_Plattform/Synology/"
      }}>{`hier`}</a>{` ein Video.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      